import "./App.css";
import { EvModeProvider } from "./context/EvModeContext";
import { loadTrackingScripts } from "../src/utils/loadTracking";
import Home from "./Pages/Home/Home";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Listing from "./Pages/Listing/Listing";
import Booking from "./Pages/Booking/Booking";
import Termsandcondition from "./Pages/T&C/Termsandconditions";
import SubscriptionTermsandcondition from './Pages/T&C/SubscriptionTermsandconditions';
import Privacypolicies from "./Pages/Privacypolicy/Privacypolicy";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import ProfileCard from "./Pages/Profile/Profile";
import Bookingstatus from "./Pages/Bookingstatus/Bookingstatus";
import Delivery from "./Pages/Deliverystatus/Delivery";
import Refund from "./Pages/Refundstatus/Refund";
import { useEffect } from "react";
import Partner from "./Pages/Partner/Partner";
import FAQ from "./Pages/FAQ/FAQ";
import Extendstatus from "./Pages/Extendstatus/Extendstatus";
import Bangalore from "./Pages/pageforbangalore/Bangalore";
import Mysore from "./Pages/pageformysore/Mysore";
import Vellore from "./Pages/pageforvellore/Vellore";
import Chennai from "./Pages/pageforchennai/Chennai";
import Salem from "./Pages/pageforsalem/Salem";
import Trichy from "./Pages/pagefortrichy/Trichy";
import Coimbatore from "./Pages/pageforcoimbatore/Coimbatore";
import ScrollToTop from "./components/ScrollToTop";
import AboutUsPage from "./Pages/about/about";
import Madurai from "./Pages/pageformadurai/Madurai";
import Login from "./Pages/login/Login";
import Signin from "./Pages/Signin/Signin";
import ValentineHearts from "./common/ValentineHearts";
import Pondicherry from "./Pages/pageforpondicherry/Pondicherry";
import DirectAIChat from './components/Chatbot/Chatbot';
import DeleteAccount from './Pages/DeleteAccount/DeleteAccount';
import SubListing from './Pages/SubListing/SubListing';
import ViewdetailsPage from './Pages/Viewdetails/Viewdetails';
const apiUrl = process.env.REACT_APP_API_BASE_URL;
const token = localStorage.getItem("tokenWebsite");
// Note: token and bookingId are read where needed to ensure latest values

const clearLocalStorageDaily = () => {
  const today = new Date().toISOString().split("T")[0]; // format: "YYYY-MM-DD"
  const lastVisit = localStorage.getItem("lastVisitDate");

  if (lastVisit !== today) {
    localStorage.clear();
    localStorage.removeItem("id");
    localStorage.removeItem("islogin");
    localStorage.removeItem("loginTime");
    localStorage.removeItem("profileName");
    localStorage.removeItem("profileinfo");
    localStorage.removeItem("tokenWebsite");
    localStorage.removeItem("bookingvalues");
    localStorage.setItem("lastVisitDate", today);
  }
};

const getCatalogMastersById = async (masterKeys) => {
  const loop = masterKeys
    .map((item, index) => {
      if (item < 100) {
        return `masterId=${item}&`;
      } else {
        return `masterId=${item}`;
      }
    })
    .join("");

  const url = `${apiUrl}/api/catalogs?${loop}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `${token}`,
      },
    });
    const data = await response.json();
    if (data) {
      localStorage.setItem("catalogValues", JSON.stringify(data));
    } else {
      console.error("Unexpected API response:", data);
    }
  } catch (error) {
    console.error("Error fetching City Names:", error);
  }
};

const getCatalogMasters = async () => {
  try {
    const response = await fetch(`${apiUrl}/api/catalogmasters`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const data = await response.json();
    if (data) {
      localStorage.setItem("catalogMaster", JSON.stringify(data?.inverted));
      const masterKeys = Object.keys(data?.index);
      getCatalogMastersById(masterKeys);
    } else {
      console.error("Unexpected API response:", data);
    }
  } catch (error) {
    console.error("Error fetching City Names:", error);
  }
};

// Checks login when the route renders, not when App first mounted — so a user who logs in
// mid-session (e.g. Book Now → login → checkout) can still reach My Bookings
const RequireLogin = ({ children }) =>
  localStorage.getItem("islogin") ? children : <Navigate to="/login" replace />;

function App() {
  const profile = localStorage.getItem("islogin");

  useEffect(() => {
    clearLocalStorageDaily();
  }, []);

  useEffect(() => {
    getCatalogMasters();
  }, []);

  useEffect(() => {}, [profile]);

  useEffect(() => {
    loadTrackingScripts();
  }, []);

  return (
    <div className="App">
      <EvModeProvider>
      <Router>        
        <ScrollToTop />
        {/* <DirectAIChat /> */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/listings" element={<Listing />} />

          <Route path="/bookings" element={<Booking />} />
          <Route path="/tandc" element={<Termsandcondition />} />
          <Route path="/subscription-tandc" element={<SubscriptionTermsandcondition />} />
          <Route path="/privacypolicy" element={<Privacypolicies />} />
          <Route path="/profile" element={<RequireLogin><ProfileCard /></RequireLogin>} />
          <Route path="/bookingstatus" element={<Bookingstatus />} />
          <Route path="/deliverystatus" element={<Delivery />} />
          <Route path="/refundstatus" element={<Refund />} />
          <Route path="/viewdetails" element={<ViewdetailsPage />} />
          <Route path="/partnerwithus" element={<Partner />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/extendstatus" element={<Extendstatus />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path='/login' element={<Login/>}/>
          <Route path='/signin' element={<Signin/>}/>
          <Route path="/self-drive-cars-bangalore" element={<Bangalore />} />
          <Route path="/self-drive-cars-mysore" element={<Mysore />} />
          <Route path="/self-drive-cars-vellore" element={<Vellore />} />
          <Route path="/self-drive-cars-chennai" element={<Chennai />} />
          <Route path="/self-drive-cars-salem" element={<Salem />} />
          <Route path="/self-drive-cars-trichy" element={<Trichy />} />
          <Route path="/self-drive-cars-coimbatore" element={<Coimbatore />} />
          <Route path="/self-drive-cars-madurai" element={<Madurai />} />
          <Route path="/self-drive-cars-pondicherry" element={<Pondicherry />} />
        </Routes>
      </Router>
      </EvModeProvider>
      <ToastContainer position="top-right" autoClose={3000} style={{ zIndex: 99999 }} />
    </div>
  );
}

export default App;